import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton, Stack, Tooltip } from '@mui/material';

import { ReactComponent as EyeIcon } from '@/assets/icons/eye-outline-icon.svg';
import { ReactComponent as PrinterIcon } from '@/assets/icons/printer-outline-icon.svg';
import { ReactComponent as VoidIcon } from '@/assets/icons/x-circle-red-icon.svg';

import { PendingPickupRow } from '../../../model/pendingPickups';

export interface PendingPickupActionHandlers {
  onPrint: (row: PendingPickupRow) => void;
  onView: (row: PendingPickupRow) => void;
  onVoid: (row: PendingPickupRow) => void;
}

interface PendingPickupActionsProps extends PendingPickupActionHandlers {
  row: PendingPickupRow;
}

const ACTION_BUTTON_SX = { p: 0, width: '1.375rem', height: '1.375rem' };

const PendingPickupActions: FC<PendingPickupActionsProps> = ({ row, onPrint, onView, onVoid }) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap="0.625rem"
      sx={{
        border: '1px solid',
        borderColor: 'grey.100',
        borderRadius: '9999px',
        padding: '0.25rem 0.5rem',
      }}
      onClick={(event) => event.stopPropagation()}
    >
      <Tooltip title={t('awb.print_label')}>
        <IconButton
          sx={ACTION_BUTTON_SX}
          disabled={!row.shipment?.awbNumber}
          onClick={() => onPrint(row)}
          data-testid="pending-pickup-print"
        >
          <PrinterIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={t('awb.details_title')}>
        <IconButton
          sx={ACTION_BUTTON_SX}
          onClick={() => onView(row)}
          data-testid="pending-pickup-view"
        >
          <EyeIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={t('awb.cancel_title')}>
        <IconButton
          sx={ACTION_BUTTON_SX}
          disabled={!row.shipment?.awbNumber}
          onClick={() => onVoid(row)}
          data-testid="pending-pickup-void"
        >
          <VoidIcon />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

export default PendingPickupActions;
